/**
 * Политика доступа (E3.12): область — виды хранилищ со снимками прав, явные ресурсы, группы и
 * типы данных (виды и типы — И, ресурсы и группы — ИЛИ, пусто — все ресурсы видов); условия —
 * публичный доступ, субъект вне разрешённых, размещение вне групп. Политика только обнаруживает
 * доказанные нарушения по снимкам прав, права источника она не меняет.
 */
export type AccessResourceKind = 's3_bucket' | 'kafka_instance' | 'nosql_database';
export type AccessAction = 'read' | 'write' | 'admin';
export type AccessConditionCode =
	| 'public_access'
	| 'principal_not_allowed'
	| 'placement_outside_group';

export const ACCESS_RESOURCE_KINDS: AccessResourceKind[] = [
	's3_bucket',
	'kafka_instance',
	'nosql_database',
];
export const ACCESS_ACTIONS: AccessAction[] = ['read', 'write', 'admin'];
export const ACCESS_CONDITION_CODES: AccessConditionCode[] = [
	'public_access',
	'principal_not_allowed',
	'placement_outside_group',
];

export interface AccessScope {
	resource_kinds: AccessResourceKind[];
	resource_refs: { kind: AccessResourceKind; id: string }[];
	group_ids: string[];
	data_type_ids: string[];
}

export interface AccessCondition {
	code: AccessConditionCode;
	actions: AccessAction[];
	allowed_principals: string[];
	allowed_group_ids: string[];
}

/**
 * Состояние оценки (только в ответе): последний такт (epoch ms; null — ещё не оценивалась),
 * причина, по которой определение не оценивается, и число ресурсов текущей ревизии с
 * нарушением, без нарушений и с неизвестным итогом
 */
export interface AccessEvaluation {
	evaluated_at: number | null;
	skipped_reason: string | null;
	violations: number;
	clear: number;
	unknown: number;
}

/** Определение в запросе и ответе; revision и evaluation — только в ответе */
export interface AccessDefinition {
	scope: AccessScope;
	conditions: AccessCondition[];
	revision?: number;
	evaluation?: AccessEvaluation;
}

export const EMPTY_ACCESS_DEFINITION: AccessDefinition = {
	scope: { resource_kinds: [], resource_refs: [], group_ids: [], data_type_ids: [] },
	conditions: [],
};
